const english = {

}

export default english
